import { render } from "./breadcrumbs.vue?vue&type=template&id=3a8fa37f&scoped=true&lang=pug"
import script from "./breadcrumbs.vue?vue&type=script&lang=js"
export * from "./breadcrumbs.vue?vue&type=script&lang=js"

import "./breadcrumbs.vue?vue&type=style&index=0&id=3a8fa37f&scoped=true&lang=css"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a8fa37f"]])

export default __exports__